import { render, staticRenderFns } from "./TrainingOnDemand.vue?vue&type=template&id=562cf752&scoped=true"
import script from "./TrainingOnDemand.vue?vue&type=script&lang=js"
export * from "./TrainingOnDemand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562cf752",
  null
  
)

export default component.exports